import { BaseCrudStore } from '@monorepo/controlled/src/stores/base-crud.store';
import { FormError } from '@monorepo/tools/src/lib/models/form-error.model';
import { DomainFactorsApi } from '../../apis/domain-factors.api';
import { HttpError } from '../../models/http-error.model';
import { DomainFactorModel, IDomainFactorCreateForm, IDomainFactorEditForm } from '../../models/domain-factor.model';
import { runInAction } from 'mobx';
import { id } from '@monorepo/tools/src/lib/types/primitives';
import { ICrudAPI } from '@monorepo/tools/src/lib/interfaces/crud';

export class DomainFactorCrudStore extends BaseCrudStore<DomainFactorModel, IDomainFactorCreateForm, IDomainFactorEditForm, HttpError> {
	constructor() {
		super({
			apiLayer: DomainFactorsApi as ICrudAPI<DomainFactorModel, IDomainFactorCreateForm, IDomainFactorEditForm>,
			model: DomainFactorModel,
			errorModel: HttpError,
		});
	}

	/**
	 * Must call isValid before calling this function
	 * @returns
	 */
	public getCreateFormData(): IDomainFactorCreateForm {
		return {
			domain: this.getData().getDomain(),
			campaign_id: this.getData().getCampaignId(),
			daily_max_loss_factor: this.getData().getDailyMaxLossFactor(),
		};
	}

	/**
	 * Must call isValid before calling this function
	 * @returns
	 */
	public getEditFormData(): IDomainFactorEditForm {
		return {
			id: this.getData().getId(),
			domain: this.getData().getDomain(),
			campaign_id: this.getData().getCampaignId(),
			daily_max_loss_factor: this.getData().getDailyMaxLossFactor(),
		};
	}

	public isValid(): boolean {
		const domain = this.getData().getDomain();
		const campaignId = this.getData().getCampaignId();
		if (!domain?.trim()) {
			this.formStore.addError(new FormError('domain', 'Please provide a domain'));
		}
		if (campaignId == null || campaignId === '') {
			this.formStore.addError(new FormError('campaign_id', 'Please select a campaign'));
		}
		const dailyMaxLossFactor = this.getData().getDailyMaxLossFactor();
		if (dailyMaxLossFactor == null) {
			this.formStore.addError(new FormError('daily_max_loss_factor', 'Please provide a daily max loss factor'));
		}

		return this.formStore.getIsValid();
	}

	public delete(ids: id | id[]): Promise<void | HttpError> {
		const idsToDelete = Array.isArray(ids) ? ids : [ids];
		this.setIsLoading(true);
		this.setIsSuccess(false);
		return DomainFactorsApi.delete(idsToDelete)
			.then(() => {
				runInAction(() => {
					this.setIsLoading(false);
					this.setIsSuccess(true);
				});
			})
			.catch(error => {
				if (this.onError) {
					this.onError(error.data);
				}
				runInAction(() => {
					this.setHttpError(new HttpError({ ...error.data, httpStatus: error.response?.status }));
					this.setIsLoading(false);
					this.setIsSuccess(false);
				});
				return error;
			});
	}
	public edit(): Promise<void> {
		this.setIsLoading(true);
		this.setIsSuccess(false);
		return DomainFactorsApi.edit(this.getEditFormData())
			.then(() => {
				runInAction(() => {
					this.setIsLoading(false);
					this.setIsSuccess(true);
				});
			})
			.catch(error => {
				if (this.onError) {
					this.onError(error.data);
				}
				runInAction(() => {
					this.setHttpError(new HttpError({ ...error.data, httpStatus: error.response?.status }));
					this.setIsLoading(false);
					this.setIsSuccess(false);
				});
				return error;
			});
	}
}
